import { Dialog } from '@headlessui/react';
import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import clsx from 'clsx';
import { useRef, useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { Arrow } from '../../slider/ImageSlider';

interface IImagePreviewDialog {
  open: boolean;
  onClose: () => void;
  images: { data: string }[];
  startingIndex: number;
}
export const ImagePreviewDialog: React.FC<IImagePreviewDialog> = ({
  open,
  onClose,
  images,
  startingIndex,
}) => {
  const [currentSlide, setCurrentSlide] = useState(startingIndex);
  const { isSm } = useWindowSize();
  let imageMockRef = useRef(null);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="relative z-[10000]"
      initialFocus={imageMockRef}
    >
      <div
        className="fixed inset-0 bg-black/70 "
        aria-hidden="true"
        style={{
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
        }}
      />
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        onClick={() => {
          onClose();
        }}
      >
        <div className="w-full sm:w-1/2 sm:h-[90%] h-[60%]" id="slider-dialog">
          <Slide
            easing="ease-in"
            canSwipe={isTablet || isMobile || !isSm}
            autoplay={false}
            transitionDuration={500}
            defaultIndex={startingIndex}
            onChange={(from, to) => setCurrentSlide(to)}
            indicators={index => (
              <div
                className={clsx(
                  'rounded-full w-2 h-2',
                  currentSlide === index ? 'bg-primary' : 'bg-primary-10'
                )}
              />
            )}
            arrows={isSm}
            prevArrow={<Arrow side="left" variant="dialog" />}
            nextArrow={<Arrow side="right" variant="dialog" />}
          >
            {images.map((image, i) => (
              <div
                className="flex items-center justify-center w-full h-full each-slide-effect"
                key={i}
              >
                <div
                  className="flex items-center justify-center w-full h-full sm:w-[80%]"
                  ref={imageMockRef}
                >
                  <img
                    src={`data:image/png;base64,${image.data}`}
                    alt=""
                    width={400}
                    height={400}
                    className={clsx(
                      isSm ? 'object-fill w-full' : 'object-contain h-[90%]'
                    )}
                    // layout={isSm ? 'responsive' : 'intrinsic'}
                    onClick={e => e.stopPropagation()}
                  />
                </div>
              </div>
            ))}
          </Slide>
        </div>
        <div
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            zIndex: 100,
          }}
        >
          <button
            onClick={onClose}
            className={clsx(
              'outline-none text-center font-medium bg-secondary',
              'inline-flex items-center justify-center transition-shadow transition-color ',
              'p-1 focus:border-primary focus:bg-primary-5 border border-transparent focus:outline-none',
              'rounded-full hover:bg-primary-10 active:bg-primary-15'
            )}
          >
            <Icon path={mdiClose} size={1} className="text-white" />
          </button>
        </div>
      </div>
    </Dialog>
  );
};
